import axios from "axios";
import Mailjet from "node-mailjet";

const username = 'ecb9d63f2342d348a40de37410c67585';
const secret = 'd5d597b525c8e5dd38311a2f7bff3a4d';

const mailjet = Mailjet.apiConnect(
    'ecb9d63f2342d348a40de37410c67585',
    'd5d597b525c8e5dd38311a2f7bff3a4d',
);


export const requestMailServ = ()=>mailjet
    .post('send', { version: 'v3.1' })
    .request({
        Messages: [
            {
                From: {
                    Email: "contact@superfun-nwa.com",
                    Name: "Mailjet Pilot"
                },
                To: [
                    {
                        Email: "passenger1@mailjet.com",
                        Name: "passenger 1"
                    }
                ],
                Subject: "Your email flight plan!",
                TextPart: "Dear passenger 1, welcome to Mailjet! May the delivery force be with you!",
                HTMLPart: "<h3>Dear passenger 1, welcome to <a href=\"https://www.mailjet.com/\">Mailjet</a>!</h3><br />May the delivery force be with you!"
            }
        ]
    })
    .then((result) => {
        console.log(result.body)
    })
    .catch((err) => {
        console.log(err.statusCode)
    })

export const sendMail = async (from: string,
    emailFrom: string,
    subject: string,
    body: string) => {
    const dataForm = JSON.stringify({
        "Messages": [{
            "From": { "Email": emailFrom, "Name": from },
            "To": [{ "Email": 'contact@superfun-nwa.com', "Name": 'web request' }],
            "Subject": subject,
            "TextPart": body
        }]
    });
    const config = {
        method: 'post',
        url: 'https://api.mailjet.com/v3.1/send',
        data: dataForm,
        headers: { 'Content-Type': 'application/json' },
        auth: { username, password: secret },
    };

    debugger
    return await axios(config)
        .then(function (response) {
            debugger
            console.log(JSON.stringify(response.data));
            return 1;
        })
        .catch(function (error) {
            debugger
            console.log(error);
            return 0;
        });


}